import { ProductDesign } from '@inter-ikea-storageone/range';
import BlackBrown from './icons/black_brown.jpg';
import White from './icons/white.jpg';
import BrownStainedAsh from './icons/brown_stained_ash.jpg';
import WhiteStainedOak from './icons/white_stained_oak.jpg';
import Oak from './icons/oak.jpg';
import BillyOak from './icons/billyOak.png';
import GreyStainedAsh from './icons/grey_stained_ash.jpg';
import GreyStainedWalnut from './icons/grey_stained_walnut.jpg';
import Beige from './icons/beige.jpg';
import DarkGrey from './icons/dark_grey.jpg';
import BlackOak from './icons/black_oak.png';
import Birch from './icons/birch.png';
import DarkBrownOak from './icons/brown_oak.png';
import BrownWalnut from './icons/walnut.png';
import HighGloss from './icons/high-gloss-white.jpg';
import GreyWood from './icons/grey-wood-effect.jpg';
import DarkGreen from './icons/dark-green.jpg';
import WalnutEffectLightGrey from './icons/walnut-effect-light-grey.jpg';
import Anthracite from './icons/anthracite.png';
import LightGrey from 'rangeConfig/eket/ui/Colors/icons/light_grey.png';
import PalePink from 'rangeConfig/eket/ui/Colors/icons/pale_pink.png';
import LightGreen from 'rangeConfig/eket/ui/Colors/icons/light_green.png';
import RedBrown from 'rangeConfig/eket/ui/Colors/icons/red_brown.png';
import GreyGreen from 'rangeConfig/eket/ui/Colors/icons/grey_green.png';
import LightGreyBlue from 'rangeConfig/eket/ui/Colors/icons/light_grey_blue.png';
import PaleYellow from 'rangeConfig/eket/ui/Colors/icons/pale_yellow.png';
import Grey from 'rangeConfig/boaxel/ui/Colors/icons/grey.png';
import Black from 'rangeConfig/bror/ui/Colors/icons/black.png';
import { getRange } from 'utils/queryUtils';

export const getIconForDesign = (design: ProductDesign) => {
  switch (design) {
    case ProductDesign.WHITE: {
      return White;
    }
    case ProductDesign.BLACK_BROWN: {
      return BlackBrown;
    }
    case ProductDesign.BROWN_STAINED_ASH: {
      return BrownStainedAsh;
    }
    case ProductDesign.WHITE_STAINED_OAK: {
      return WhiteStainedOak;
    }
    case ProductDesign.OAK: {
      if (getRange() === 'billy') return BillyOak;
      return Oak;
    }
    case ProductDesign.GREY_STAINED_ASH: {
      return GreyStainedAsh;
    }
    case ProductDesign.GREY_STAINED_WALNUT: {
      return GreyStainedWalnut;
    }
    case ProductDesign.BEIGE: {
      return Beige;
    }
    case ProductDesign.DARK_GREY: {
      return DarkGrey;
    }
    case ProductDesign.BLACK_OAK: {
      return BlackOak;
    }
    case ProductDesign.BIRCH: {
      return Birch;
    }
    case ProductDesign.DARK_BROWN_OAK: {
      return DarkBrownOak;
    }
    case ProductDesign.BROWN_WALNUT_EFFECT: {
      return BrownWalnut;
    }
    case ProductDesign.DARK_GREEN: {
      return DarkGreen;
    }
    case ProductDesign.HIGH_GLOSS_WHITE: {
      return HighGloss;
    }
    case ProductDesign.GREY_WOOD_EFFECT: {
      return GreyWood;
    }
    case ProductDesign.WALNUT_EFFECT_LIGHT_GREY: {
      return WalnutEffectLightGrey;
    }
    case ProductDesign.ANTHRACITE: {
      return Anthracite;
    }
    case ProductDesign.LIGHT_GREY: {
      return LightGrey;
    }
    case ProductDesign.PALE_PINK: {
      return PalePink;
    }
    case ProductDesign.LIGHT_GREEN: {
      return LightGreen;
    }
    case ProductDesign.RED_BROWN: {
      return RedBrown;
    }
    case ProductDesign.GREY_GREEN: {
      return GreyGreen;
    }
    case ProductDesign.LIGHT_GREY_BLUE: {
      return LightGreyBlue;
    }
    case ProductDesign.PALE_YELLOW: {
      return PaleYellow;
    }
    case ProductDesign.GREY: {
      return Grey;
    }
    case ProductDesign.BLACK: {
      return Black;
    }
  }
};
